<template>
  <div class="sender">
    <h4><i class="icon-arrow-bar-left text-yellow"></i>{{ $lang.translate('track.header.sender') }}:</h4>
    <p>
      <span v-if="result.from.name">{{ result.from.name }}</span>
      <span v-if="result.from.street">{{ result.from.street }}</span>
      <span v-if="result.from.zipAndCity">{{ result.from.zipAndCity }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Sender',
  props: {
    result: {
      type: Object,
      required: true
    },
    customClass: {
      type: String,
      required: false,
      default: 'is-third'
    }
  }
}
</script>
<style scoped>
.sender p span {
  display: block;
}
</style>